import React from "react"

import { Color, Size } from "~tailwindui/types/enums"

import { path } from "~Tutor/TutorRoutes"
import CancelSessionButton from "~Tutor/components/Sessions/CancelSessionButton"
import RequestSubstitute from "~Tutor/components/Sessions/RequestSubstituteButton"
import RescheduleSessionButton from "~Tutor/components/Sessions/RescheduleSessionButton"
import { StyledLink } from "~tailwindui/Basics"

import TutorCloudroomButton from "components/Tutor/components/Sessions/TutorCloudroomButton"

type Session = {
  id: string
  cloudroomActive: boolean
  startsAt: string
  statusState: string
  billState: string
  future: boolean
  immovable: boolean
  mayCancelByTutor: boolean
  mayRequestSubstituteByTutor: boolean
  subRequestsLeft?: number
}

export type SessionButtonsProps = {
  session: Session
}

const SessionButtons: React.FC<SessionButtonsProps> = ({ session }) => {
  const completable =
    !session.future &&
    session.statusState === "scheduled" &&
    session.billState === "unbilled"

  const reschedulable =
    session.billState === "unbilled" &&
    session.statusState === "scheduled" &&
    session.future &&
    !session.immovable

  const cancelable =
    session.billState === "unbilled" &&
    session.mayCancelByTutor &&
    session.future

  return (
    <div className="flex flex-col justify-center space-y-2">
      {session.statusState !== "canceled" && session.cloudroomActive && (
        <TutorCloudroomButton
          startsAt={session.startsAt}
          id={session.id}
          className="flex justify-center"
          buttonSize={Size.Medium}
        />
      )}

      {completable && (
        <StyledLink
          to={path("sessionBill", { id: session.id })}
          button
          color={Color.Teal}
          size={Size.Medium}
        >
          Complete
        </StyledLink>
      )}

      {reschedulable && (
        <RescheduleSessionButton id={session.id} size="normal" />
      )}

      {cancelable && <CancelSessionButton id={session.id} />}

      {session.mayRequestSubstituteByTutor && (
        <RequestSubstitute
          id={session.id}
          startsAt={session.startsAt}
          subRequestsLeft={session.subRequestsLeft}
        />
      )}
    </div>
  )
}

export default SessionButtons
